import { render, staticRenderFns } from "./SeguimientoAcciones.vue?vue&type=template&id=2a19c3a5&"
import script from "./SeguimientoAcciones.vue?vue&type=script&lang=js&"
export * from "./SeguimientoAcciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports